import {levelNumber, log, mapData, userLevelAtLeastPure, userLevelNumberPure} from "../Tools";
import {isMobile} from '../PureTools';
import L from 'leaflet';
import {
    ActionType,
    ADD_FLIGHT,
    ADD_FLIGHTS,
    ADD_LOCATIONS,
    CONVERT_FLIGHTS,
    DEQUEUE,
    EDIT_FLIGHT,
    ENQUEUE,
    FORCE_CENTER_MAP,
    JUMP_TO_MAP,
    LOGIN,
    LOGOUT,
    MAP_NEXT,
    PAN_TO,
    REMOVE_ALL_FLIGHTS,
    RESIZE,
    SET_FLIGHTS,
    SET_HOVERED_CITY,
    SET_HOVERED_FLIGHT,
    SET_MAP_REFERENCE_GOOGLE,
    SET_MAP_REFERENCE_LEAFLET,
    SET_MAP_ZOOM_GOOGLE,
    SET_MAP_ZOOM_LEAFLET,
    SET_MARKER,
    SET_PICS,
    SET_SETTINGS,
    TOGGLE_ADD_AIRLINE,
    TOGGLE_CHARTS,
    TOGGLE_CONSENT,
    TOGGLE_EDIT,
    TOGGLE_FEEDBACK,
    TOGGLE_FILTER,
    TOGGLE_GLOBE,
    TOGGLE_MAP_SELECTION,
    TOGGLE_MATRIX,
    TOGGLE_MENU,
    TOGGLE_MORE,
    TOGGLE_POLICY,
    TOGGLE_REGISTER,
    TOGGLE_RESET,
    TOGGLE_SEARCH,
    TOGGLE_SETTINGS,
    TOGGLE_SHOWCASE,
    TOGGLE_STATS,
    TOGGLE_TABLES,
    TOGGLE_TUTORIAL,
    TOGGLE_VERIFY,
    TOGGLE_WELCOME,
    TOGGLE_WHATSNEW,
    UNVEIL
} from "../actions/action";
import {homebaseLocationData} from '../Constants';
import {StateType} from "../store";
import {LEVEL_GOOGLE_MAP, SILVER_MAPS} from "../UserLevelConstants";

export let loginTime = {time: -1};

const allModesToFalse = {
    editFlightNumber: -1,
    showGlobe: -1,
    showTableNumber: -1,
    showCharts: -1,
    isFilter: false,
    showShowcase: null,
    showMenu: false,
    showSearch: false,
    showSettings: false,
    markerPosition: null,
    showFeedback: false,
    showMapSelection: false,
};

/*
const updateLocalStorage = (flights: any, locations: any, pics: any) => {
const storageItem = {
    flights: flights,
    locations: locations,
    pics: pics
};
localStorage.setItem('flightData', JSON.stringify(storageItem));
    localStorage.setItem('savedData', 'true');
    log('updated localstorage');
};
*/




//*********************

const initialState: StateType = {
    allFlights: [],
    flights: [],
    locations: {
        hel: homebaseLocationData
    },
    pics: {},
    veil: true,
    editFlightNumber: -1,
    isFilter: false,
    showGlobe: -1,
    showMenu: false,
    showTableNumber: -1,
    showCharts: -1,
    showStats: false,
    showShowcase: null,
    showTutorial: false,
    showSettings: false,
    showRegister: false,
    showReset: false,
    showVerify: false,
    showMatrix: false,
    showFeedback: false,
    showMapSelection: false,
    showWhatsNew: false,
    spinner: false,
    showLogin: true,
    incompleteQueue: [],
    dateFilter: {min: 0, max: 0},
    airlineFilter: '',
    purposeFilter: '',
    modelFilter: '',
    filterApplied: false,
    hoveredCity: {
        hoveredCity: null,
        hoveredCityPosition: {
            x: null,
            y: null
        },
        flights: []
    },
    hoveredFlight: null,
    centerMap: false,
    user: null,
    mapType: -1,
    windowWidth: 0,
    windowHeight: 0,
    mapReferenceGoogle: null,
    mapZoomGoogle: 3,
    mapReferenceLeaflet: null,
    mapZoomLeaflet: 3,
    markerPosition: null,
    showSearch: false,
    showMore: false,
    showConsent: false,
    showPolicy: false,
    showAddAirline: false,
    unverifiedEmail: '',
    welcomeState: -1
};

//*********************

const reducer = (state: StateType = initialState, action: ActionType) => {
    const clearModesIfToggleOn = action.payload ? allModesToFalse : {};
    const clearModesIfSet = action.payload !== -1 ? allModesToFalse : {};
    const clearModes = allModesToFalse;

    switch (action.type) {
        case JUMP_TO_MAP: {
            log('REDUCER:jump_to_map');
            return {
                ...state,
                mapType: action.payload
            }
        }
        case MAP_NEXT: {
            log('REDUCER:map_next');
            const firstMapNumber = userLevelAtLeastPure(LEVEL_GOOGLE_MAP, state.user!) ? -1 : 0;
            const isSilver = userLevelNumberPure(state.user!) === levelNumber('silver');
            let newMapType;
            if (isSilver) {
                const currentPosition = SILVER_MAPS.indexOf(state.mapType);
                newMapType = (currentPosition < SILVER_MAPS.length - 1) ? SILVER_MAPS[currentPosition + 1] : SILVER_MAPS[0];
            } else {
                newMapType = (state.mapType < mapData().length - 1) ? (state.mapType + 1) : firstMapNumber;
            }
            return {
                ...state,
                mapType: newMapType
            }
        }
        // TODO is this good here? no change to state...
        case PAN_TO: {
            log('REDUCER:panTo');
            if (state.mapReferenceLeaflet) {
                // prevent leaflet timing issues
                setTimeout(() => {
                    const latLng = new L.LatLng(action.payload.lat, action.payload.lng);
                    state.mapReferenceLeaflet.leafletElement.setView(latLng, state.mapZoomLeaflet);
                }, 100);
            }
            return state;
        }
        case SET_MARKER: {
            log('REDUCER:setMarker');
            return {
                ...state,
                markerPosition: action.payload,
            }
        }
        case RESIZE: {
            log('REDUCER:resize');
            return {
                ...state,
                windowWidth: document.getElementById('root')!.scrollWidth,
                windowHeight: document.getElementById('root')!.clientHeight
            }
        }
        case SET_MAP_REFERENCE_GOOGLE: {
            log('REDUCER:setMapReferenceGoogle');
            return {
                ...state,
                mapReferenceGoogle: action.payload
            }
        }
        case SET_MAP_REFERENCE_LEAFLET: {
            log('REDUCER:setMapReferenceLeaflet');
            return {
                ...state,
                mapReferenceLeaflet: action.payload
            }
        }
        case SET_MAP_ZOOM_GOOGLE: {
            log('REDUCER:setMapZoomGoogle');
            return {
                ...state,
                mapZoomGoogle: action.payload
            }
        }
        case SET_MAP_ZOOM_LEAFLET: {
            log('REDUCER:setMapZoomLeaflet');
            return {
                ...state,
                mapZoomLeaflet: action.payload
            }
        }
        case REMOVE_ALL_FLIGHTS: {
            log('REDUCER:remove_all_flights');
            //TODO clear filter since we are updating also filtered flights
            //TODO FIXME move to a subscriber
            return {
                ...state,
                allFlights: [],
                flights: [],
                locations: {hel: homebaseLocationData}
            };
        }
        //TODO rename to set locations
        case ADD_LOCATIONS:
            log('REDUCER:add_locations');
            const newLocations2 = action.payload;
            //TODO FIXME move to a subscriber
            Object.values(newLocations2).forEach((location: any) => {
               if (location.continent.length > 2) {
                   log('converting continent in location');

                   const locationConversion: any = {
                       'northamerica': 'na',
                       'southamerica': 'sa',
                       'africa': 'af',
                       'asia': 'as',
                       'oceania': 'oc',
                       'europe': 'eu',
                       'caribbean': 'na',
                       'centralamerica': 'na'
                   };
                   location.continent = locationConversion[location.continent];
               }
            });

            //updateLocalStorage(state.allFlights, newLocations2, state.pics);
            return {
                ...state,
                locations: newLocations2
            };
        case ADD_FLIGHT:
            log('REDUCER:add_flight');
            const tempFlights = [...state.allFlights];
            tempFlights.push(action.payload);
            const flights = [...tempFlights];
            //TODO clear filter since we are updating also filtered flights
            //TODO FIXME move to a subscriber
            //updateLocalStorage(tempFlights, state.locations, state.pics);
            return {
                ...state,
                allFlights: tempFlights,
                flights
            };
        case EDIT_FLIGHT:
            log('REDUCER:edit_flight');
            const tempFlights2 = [...state.allFlights].filter(o => o.id !== action.payload.id);
            tempFlights2.push(action.payload);
            const flights2 = [...tempFlights2];
            //TODO clear filter since we are updating also filtered flights
            //TODO FIXME move to a subscriber
            //updateLocalStorage(tempFlights2, state.locations, state.pics);
            return {
                ...state,
                allFlights: tempFlights2,
                flights: flights2
            };
        case ADD_FLIGHTS:
            log('REDUCER:add_flights');

            const allFlights3 = [...state.allFlights];
            allFlights3.push(...action.payload);
            const flights3 = [...allFlights3];
            //TODO FIXME move to a subscriber
            //updateLocalStorage(allFlights3, state.locations, state.pics);
            return {
                ...state,
                allFlights: allFlights3,
                flights: flights3,
                dateFilter: null,
                airlineFilter: '***',
                purposeFilter: '***',
                modelFilter: '***'
            };
        case SET_FLIGHTS:
            log('REDUCER:set_flights');

            const replacementFlights = action.payload;
            //TODO FIXME move to a subscriber
            //updateLocalStorage(replacementFlights, state.locations, state.pics);
            return {
                ...state,
                allFlights: replacementFlights,
                flights: replacementFlights,
                dateFilter: null,
                airlineFilter: '***',
                purposeFilter: '***',
                modelFilter: '***'
            };
        // convert to a newer data model
        case CONVERT_FLIGHTS:
            log('REDUCER:convert_flights');
            //TODO rename these tempFlights3 to proper name
            const tempFlights3 = [...state.allFlights];

            for (const flight of tempFlights3) {
                log('convert', flight);
                /*
                // for old data departure/arrival does not exist, add departure time from hour/minute
                if (!flight.departure && flight.hour && flight.hour.length) {
                    flight.departure = {
                        hour: Number(flight.hour),
                        minute: Number(flight.minute)
                    }
                }

                // recalc distance
                const fromLocation = state.locations[flight.from];
                const toLocation = state.locations[flight.to];
                const distance = getDistance(fromLocation.lat, fromLocation.lng, toLocation.lat, toLocation.lng);

                //TODO remove
                const distanceLoggerText = 'old dist:' + flight.distance + ' new dist:' + distance;

                flight.distance = distance;

                // for old data recalculate timezone
                const fromTimezoneName = getCachedTimezoneName(flight.from, state);
                const toTimezoneName = getCachedTimezoneName(flight.to, state);
                const flightTimeDetails = getFlightTimeDetails(new Date(flight.date), flight.departure, fromTimezoneName, flight.arrival, toTimezoneName);

                // for old data recalculate duration
                const duration = (flightTimeDetails.duration > 0) ? flightTimeDetails.duration : estimateDuration(distance);

                //TODO remove
                const durationLoggerText = 'duration:' + duration + ' _ ' + flightTimeDetails.duration;

                flight.hours = hoursFromTotalMinutes(duration);
                flight.minutes = minutesFromTotalMinutes(duration);

                //TODO remove
                const fromTzLoggerText = 'old fromTz:' + flight.fromTimezone + ' new fromTz:' + flightTimeDetails.fromTimezoneOffset;
                const toTzLoggerText = 'old toTz:' + flight.toTimezone + ' new totz:' + flightTimeDetails.toTimezoneOffset;

                flight.fromTimezone = flightTimeDetails.fromTimezoneOffset;
                flight.toTimezone = flightTimeDetails.toTimezoneOffset;

                // for old data convert business to purpose
                if (!flight.purpose) {
                    log('converted business');
                    flight.purpose = flight.business ? 'business' : 'leisure';
                }

                 */

                //TODO remove
                //log('converted:::::', flight.from, flight.to, flight.id, distanceLoggerText, durationLoggerText, fromTzLoggerText, toTzLoggerText);
                //log('converted:::::', flight.date);

            }

            const flights4 = [...tempFlights3];
            //TODO FIXME move to a subscriber
            //updateLocalStorage(tempFlights3, state.locations, state.pics);
            return {
                ...state,
                allFlights: tempFlights3,
                flights: flights4
            };
        case FORCE_CENTER_MAP:
            log('REDUCER:force_center_map');
            return {
                ...state,
                centerMap: !state.centerMap
            }
        case UNVEIL:
            log('REDUCER:unveil');
            return {
                ...state,
                veil: false
            };
        case TOGGLE_EDIT:
            log('REDUCER:toggle_edit');
            return {
                ...state,
                ...clearModesIfSet,
                editFlightNumber: action.payload,
                showStats: !isMobile,
                showShowcase: null
            };
        case TOGGLE_ADD_AIRLINE:
            log('REDUCER:toggle_add_airline', action.payload);
            return {
                ...state,
                showAddAirline: action.payload,
            };
        case TOGGLE_MORE:
            log('REDUCER:toggle_more', action.payload);
            return {
                ...state,
                showMore: action.payload,
            };
        case TOGGLE_CONSENT:
            log('REDUCER:toggle_consent', action.payload);
            return {
                ...state,
                showConsent: action.payload,
            };
        case TOGGLE_POLICY:
            log('REDUCER:toggle_policy', action.payload);
            return {
                ...state,
                showPolicy: action.payload,
            };
        case TOGGLE_SEARCH:
            log('REDUCER:toggle_search');
            return {
                ...state,
                ...clearModesIfToggleOn,
                showMenu: false,
                markerPosition: !action.payload ? null : state.markerPosition,
                showSearch: action.payload,
            };
        case TOGGLE_FEEDBACK:
            log('REDUCER:toggle_feedback');
            return {
                ...state,
                ...clearModesIfToggleOn,
                showMenu: false,
                showFeedback: action.payload,
            };
        case TOGGLE_MAP_SELECTION:
            log('REDUCER:toggle_map_selection');
            return {
                ...state,
                ...clearModesIfToggleOn,
                showMenu: false,
                showMapSelection: action.payload,
                showStats: !isMobile
            };
        case SET_HOVERED_FLIGHT:
            log('REDUCER:set hovered flight', action.payload);
            return {
                ...state,
                hoveredFlight: action.payload
            };
        case SET_HOVERED_CITY:
            log('REDUCER:set hovered city', action.payload);
            return {
                ...state,
                hoveredCity: action.payload
            };
        case TOGGLE_SHOWCASE:
            log('REDUCER:toggle_showcase');
            return {
                ...state,
                showShowcase: action.payload,
                showStats: action.payload ? false : !isMobile,
                hoveredCity: {city: null, hoveredCityPosition: {x: null, y: null}, flights: null},
                hoveredFlight: {flight: null, hoveredFlightPosition: {x: null, y: null}}
            };
        case LOGIN:
            log('REDUCER:login', action.payload);
            loginTime.time = Date.now();
            return {
                ...state,
                user: action.payload,
                showLogin: false,
                showStats: !isMobile,
            };
        case LOGOUT:
            log('REDUCER:logout');
            const firstMapNumber = userLevelAtLeastPure(LEVEL_GOOGLE_MAP, state.user!) ? -1 : 0;

            return {
                ...state,
                ...clearModes,
                user: null,
                showLogin: true,
                mapType: firstMapNumber,
                flights: [],
                allFlights: [],
                pics: [],
                locations: [],
                welcomeState: -1
            };
        case TOGGLE_GLOBE:
            log('REDUCER:toggle_globe!', action.payload);
            return {
                ...state,
                ...clearModesIfSet,
                showGlobe: action.payload,
                showStats: action.payload > -1 ? false : !isMobile
            };
        case TOGGLE_WELCOME:
            log('REDUCER:toggle_welcome', action.payload);
            return {
                ...state,
                welcomeState: action.payload,
            };
        case TOGGLE_TABLES:
            log('REDUCER:toggle_tables', action.payload);
            return {
                ...state,
                ...clearModesIfSet,
                showTableNumber: action.payload,
                showStats: (action.payload > -1) ? false : !isMobile
            };
        case TOGGLE_MENU:
            log('REDUCER:toggle_menu', action.payload);
            return {
                ...state,
                showMenu: action.payload && isMobile
            };
        case TOGGLE_STATS:
            log('REDUCER:toggle_stats', action.payload);
            return {
                ...state,
                ...clearModesIfToggleOn,
                showStats: action.payload
            };
        case TOGGLE_CHARTS:
            log('REDUCER:toggle_charts', action.payload);
            return {
                ...state,
                ...clearModesIfSet,
                showCharts: action.payload,
                showStats: action.payload > -1 ? false : !isMobile
            };
        case TOGGLE_FILTER:
            log('REDUCER:toggle_filter');
            return {
                ...state,
                ...clearModesIfToggleOn,
                showMenu: false,
                isFilter: action.payload
            };
        case TOGGLE_TUTORIAL:
            log('REDUCER:toggle_tutorial');
            return {
                ...state,
                showMenu: false,
                showTutorial: action.payload
            };
        case TOGGLE_SETTINGS:
            log('REDUCER:toggle_settings');
            return {
                ...state,
                showMenu: false,
                isFilter: false,
                showSettings: action.payload
            };
        case TOGGLE_REGISTER:
            log('REDUCER:toggle_register');
            return {
                ...state,
                showMenu: false,
                showRegister: action.payload
            };
        case TOGGLE_RESET:
            log('REDUCER:toggle_reset');
            return {
                ...state,
                showMenu: false,
                showReset: action.payload
            };
        case TOGGLE_VERIFY:
            log('REDUCER:toggle_verify');
            return {
                ...state,
                showMenu: false,
                unverifiedEmail: action.payload,
                showRegister: false,
                showVerify: !!action.payload
            };
        case TOGGLE_MATRIX:
            log('REDUCER:toggle_matrix');
            return {
                ...state,
                showMenu: false,
                showMatrix: action.payload
            };
        case TOGGLE_WHATSNEW:
            log('REDUCER:toggle_whatsnew');
            return {
                ...state,
                showMenu: false,
                showWhatsNew: action.payload
            };
        case SET_SETTINGS:
            log('REDUCER:set_settings');
            const oldUser = state.user!;
            const newUser = {
                ...oldUser,
                images: action.payload.images !== undefined ? action.payload.images : oldUser.images,
                km: action.payload.km !== undefined ? action.payload.km : oldUser.km,
                dateFormat: action.payload.dateFormat !== undefined ? action.payload.dateFormat : oldUser.dateFormat,
                celsius: action.payload.celsius !== undefined ? action.payload.celsius : oldUser.celsius,
                homeAirport: action.payload.homeAirport !== undefined ? action.payload.homeAirport : oldUser.homeAirport,
            }
            return {
                ...state,
                user: newUser
            };
        case SET_PICS:
            log('REDUCER:set_pics');
            const newPics2 = action.payload ? action.payload : {};
            //TODO FIXME move to a subscriber
            //updateLocalStorage(state.allFlights, state.locations, newPics2);
            return {
                ...state,
                pics: newPics2
            };
        case ENQUEUE:
            log('REDUCER:enqueue', action.payload, 'in queue:', state.incompleteQueue);
            return {
                ...state,
                spinner: true,
                incompleteQueue: [...state.incompleteQueue, action.payload]
            };
        case DEQUEUE:
            log('REDUCER:dequeue', action.payload);
            const newArray = state.incompleteQueue.filter(o => o !== action.payload);
            return {
                ...state,
                spinner: newArray.length,
                incompleteQueue: newArray
            };
        default:
            log('WARNING REDUCER not found for action ', action);
            return state;
    }
};

export default reducer;








